import { createSelector } from 'reselect';

const getState = (state) => state.mrDistribution.data.repeatedFrom;

const getRepeatedFrom = createSelector(
  getState,
  (repeatedFrom) => repeatedFrom
);

export default {
  getRepeatedFrom,
};
